module.exports = __webpack_public_path__ + "static/media/ruan.d122d79d.jpeg";